/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Input } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { usePlacesWidget } from 'react-google-autocomplete'
import { setLocation } from '../../../../../../redux/reducers/talentSlice'
import { formatLocation } from '../../../../../../utils/utils'
import * as s from './Location.styles'
const propTypes = {
  defaultValue: PropTypes.shape({
    formattedAddress: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
  }),
}
const defaultProps = {
  defaultValue: {
    formattedAddress: null,
    city: null,
    state: null,
    country: null,
  },
}
/**
 * Allows user to update his location
 */
function Location() {
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })
  const { location } = useSelector((state) => state.talent)
  const inputRef = useRef(null)
  const dispatch = useDispatch()
  const [locationState, setLocationState] = useState(location?.formattedAddress)
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    defaultValue: location?.city,
    onPlaceSelected: (place) => {
      if (inputRef.current) {
        if ('formatted_address' in place) {
          inputRef.current.input.value = place?.formatted_address
          if (place?.address_components && place?.formatted_address) {
            const location = formatLocation({
              address_components: place?.address_components,
              formatted_address: place?.formatted_address,
            })
            dispatch(setLocation(location))
            setLocationState(place?.formatted_address)
          }
        } else {
          dispatch(
            setLocation({
              formattedAddress: null,
              city: null,
              state: null,
              country: null,
            }),
          )
          setLocationState('')
        }
      }
    },
  })

  useEffect(() => {
    if (location?.formattedAddress?.length) {
      setLocationState(location.formattedAddress)
    }
  }, [location])

  return (
    <s.LocationWrapper>
      <label className="field-label">
        {t('talentArea:profile.location.label')}
      </label>
      <Input
        onChange={(e) => {
          if (!e.target.value) {
            dispatch(
              setLocation({
                formattedAddress: null,
                city: null,
                state: null,
                country: null,
              }),
            )
          }
          setLocationState(e.target.value)
        }}
        ref={(c) => {
          inputRef.current = c
          if (c) ref.current = c.input
        }}
        data-cy="location-field"
        placeholder={t('common:locationPlaceholder')}
        defaultValue={location?.formattedAddress || ''}
        value={locationState}
        size="large"
      />
    </s.LocationWrapper>
  )
}

Location.propTypes = propTypes
Location.defaultProps = defaultProps
export default Location
